export const serverRoutes = {
  availableCohorts: {
    all(partnerId: string) {
      return `/app-ac/${partnerId}` as const;
    },
    allForApp(partnerId: string) {
      return `/app-ac/${partnerId}/app` as const;
    },
    searchByCatalogueIds(partnerId: string, catalogueIds: string) {
      return `/app-ac/${partnerId}/search?catalogueIds=${catalogueIds}` as const;
    },
  },

  checkout: {
    complete(partnerId: string) {
      return `/checkout_bff/${partnerId}/complete` as const;
    },
    couponsAdd(partnerId: string) {
      return `/checkout_bff/${partnerId}/coupons` as const;
    },
    couponsRemove(partnerId: string, code: string) {
      return `/checkout_bff/${partnerId}/coupons/${code}` as const;
    },
    getCart(partnerId: string, email: string) {
      return `/checkout_bff/${partnerId}/${email}` as const;
    },
    guardian(partnerId: string) {
      return `/checkout_bff/${partnerId}/guardian` as const;
    },
    lineItemAdd(partnerId: string) {
      return `/checkout_bff/${partnerId}/items` as const;
    },
    lineItemRemove(partnerId: string, id: string) {
      return `/checkout_bff/${partnerId}/items/${id}` as const;
    },
    student(partnerId: string) {
      return `/checkout_bff/${partnerId}/student` as const;
    },
    validate(partnerId: string) {
      return `/checkout_bff/${partnerId}/validate` as const;
    },
  },

  enrollments(partnerId: string) {
    return `/enrollments/partner/${partnerId}` as const;
  },

  profiles: {
    relationships(partnerId: string) {
      return `/profiles/relationships/${partnerId}` as const;
    },
  },
};
